import {jsx as originalJsx,jsxs as originalJsxs,Fragment} from 'react/jsx-runtime';
import {forwardRef,useContext} from 'react';
import {LanguageContext} from './LanguageContext.js';
import {translateText} from './translate.js';
export {Fragment};
const attributes=['title','alt','placeholder','aria-label','aria-description'];
const textChildren=children=>typeof children==='string'||Array.isArray(children)&&children.some(textChildren);
function translateChildren(children,language){
  if(typeof children==='string')return translateText(children,language);
  if(!Array.isArray(children))return children;
  const translated=children.map(child=>translateChildren(child,language));
  // Chinese UI often joins two labels without spaces (e.g. Clear + Both hands).
  // Preserve numeric/currency punctuation while separating translated words.
  return translated.map((child,i)=>language!=='zh'&&i>0&&typeof child==='string'&&typeof translated[i-1]==='string'&&/\p{L}$/u.test(translated[i-1])&&/^\p{L}/u.test(child)?' '+child:child);
}
const LocalizedElement=forwardRef(function LocalizedElement({element,originalProps},ref){
  const {language}=useContext(LanguageContext);
  const props={...originalProps,ref};
  for(const name of attributes)if(typeof props[name]==='string')props[name]=translateText(props[name],language);
  if(!['textarea','script','style'].includes(element))props.children=translateChildren(props.children,language);
  return originalJsx(element,props);
});
function localize(factory,element,props,key){
  if(typeof element==='string'&&props?.translate!=='no'&&(textChildren(props?.children)||attributes.some(name=>typeof props?.[name]==='string'))){
    return originalJsx(LocalizedElement,{element,originalProps:props,ref:props.ref},key);
  }
  return factory(element,props,key);
}
export const jsx=(element,props,key)=>localize(originalJsx,element,props,key);
export const jsxs=(element,props,key)=>localize(originalJsxs,element,props,key);
